import { useState } from "react";

import { notificationContext } from "../context";

import { Toast } from "../../components";

const NotificationProvider = ({ children }) => {
  const [toast, setToast] = useState([]);
  const success = (text) => {
    const data = {
      id: Date.now(),
      type: "SUCCESS",
      content: text,
    };
    addToast(data);
  };

  const error = (text) => {
    const data = {
      id: Date.now(),
      type: "ERROR",
      content: text || "Technical Error,  Please check after sometimes.",
    };
    addToast(data);
  };

  const info = (text) => {
    const data = {
      id: Date.now(),
      type: "INFO",
      content: text,
    };
    addToast(data);
  };

  const warning = (text) => {
    const data = {
      id: Date.now(),
      type: "WARNING",
      content: text,
    };
    addToast(data);
  };

  const addToast = (data) => {
    if (toast?.length == 4) {
      setToast((prevData) => [data, ...prevData.slice(0, 3)]);
    } else {
      setToast((prevData) => [data, ...prevData]);
    }
    setTimeout(() => {
      clearToast(data.id);
    }, 3000);
  };

  const clearToast = (toastID) => {
    setToast((prevData) => prevData.filter((data) => data.id !== toastID));
  };

  return (
    <notificationContext.Provider
      value={{ toast, success, error, info, warning, clearToast }}
    >
      {children}
      {toast.length > 0 && <Toast />}
    </notificationContext.Provider>
  );
};

export default NotificationProvider;
